import type { SVGIconProps } from "../types";

export const JobLevelIcon: React.FC<SVGIconProps> = ({
  size = 24,
  className,
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <mask
        id="mask0_1085_125"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1085_125)">
        <path
          d="M9.08903 9.66543H7.84376L7.84284 9.66634V12.7647H9.08994L9.09086 12.7638V9.66725L9.08903 9.66543ZM13.7584 7.60563L13.7575 7.60472H12.5113L12.5104 7.60563V12.7638L12.5113 12.7647H13.7575L13.7584 12.7638V7.60563ZM10.3325 12.7628C10.3325 13.4459 9.77559 14 9.08903 14H7.84467C7.15811 14 6.60121 13.4459 6.60121 12.7628V9.66725C6.60129 8.98424 7.15816 8.431 7.84467 8.431H9.08903C9.77554 8.431 10.3324 8.98424 10.3325 9.66725V12.7628ZM15 12.7628L14.9936 12.8898C14.9299 13.5134 14.4001 14 13.7565 14H12.5122C11.8686 14 11.3388 13.5134 11.2751 12.8898L11.2687 12.7628V7.60654C11.2687 6.92347 11.8256 6.36939 12.5122 6.36939H13.7565C14.4431 6.36939 15 6.92347 15 7.60654V12.7628Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.27298 1.00907C9.69991 1.05119 10.1018 1.23894 10.408 1.54329C10.7576 1.89121 10.9538 2.36372 10.954 2.85573V3.47702H12.8228C13.853 3.47702 14.6878 4.30787 14.688 5.33275V5.62662C14.4871 5.53392 14.2313 5.48785 13.9122 5.48785H13.4464V5.33275C13.4462 4.99009 13.1673 4.71236 12.8228 4.71236H2.86518C2.52097 4.71265 2.24182 4.99027 2.24163 5.33275V8.08822C3.32814 8.75493 4.52232 9.21882 5.76506 9.46505V10.7222C4.53624 10.5047 3.34669 10.0972 2.24163 9.51131V11.5249C2.2418 11.8674 2.52096 12.145 2.86518 12.1452H5.76506V12.5461C5.76506 12.8479 5.82112 13.1322 5.93644 13.3806H2.86518C1.83527 13.3803 1.00016 12.5496 1 11.5249V5.33275C1.00018 4.30805 1.83528 3.47731 2.86518 3.47702H4.73401V2.85573C4.73418 2.36372 4.93039 1.89121 5.28007 1.54329C5.62978 1.19539 6.10466 1.00014 6.59919 1H9.08884L9.27298 1.00907ZM6.59919 2.23534C6.43394 2.23548 6.27484 2.30049 6.15797 2.41674C6.04112 2.533 5.97581 2.69133 5.97564 2.85573V3.47702H9.71239V2.85573C9.71222 2.69133 9.64691 2.533 9.53006 2.41674C9.44234 2.32963 9.33078 2.27092 9.21099 2.24713L9.08884 2.23534H6.59919Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
